module.exports = __webpack_public_path__ + "public/img/05.078ce84b.jpg";